var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
        _vm.customClass,
        {
            'save-button white-button': _vm.buttonType === 'side',
            'save-button brown-button': _vm.buttonType === 'save',
        } ],attrs:{"title":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }